import { t } from "../i18n";
import { CURRENCY } from "@degen/shared/config/content";
import { helpOpen, hud, openApp, setSpeed, sharedMode, togglePhone } from "../bridge";
import { compact, wusd } from "../format";
import type { Speed } from "@degen/sim/clock";
import { PfpImage } from "../PfpImage";
import { Tween } from "../Tween";
import { displayClock } from "../prefs";
import { COSMETICS } from "@degen/sim/progress/progress";

const frameColor = (id: string) => COSMETICS.find((c) => c.id === id)?.color ?? (id.includes("gold") ? "#facc15" : id.includes("silver") ? "#cbd5e1" : "#b45309");

const SPEEDS: { s: Speed; label: string }[] = [
  { s: 0, label: "❚❚" },
  { s: 1, label: "1×" },
  { s: 2, label: "2×" },
  { s: 4, label: "4×" },
];

export function Hud() {
  const h = hud.value;
  if (!h) return null;
  return (
    <header class="hud">
      <div class="hud-row">
        <button class="hud-id" onClick={togglePhone} aria-label="Open phone">
          <span class={`pfp-frame ${h.equipped.frame ? "on" : ""}`} style={h.equipped.frame ? { "--frame-c": frameColor(h.equipped.frame) } : undefined}>
            <PfpImage seed={h.pfpSeed} traits={h.pfpTraits} size={40} class="pfp-mini" />
          </span>
          <span class="hud-rank">
            {h.rank}
            {h.kolBadge && <span class="badge">KOL</span>}
          </span>
        </button>
        <div class="hud-stat">
          <span class="label">{CURRENCY.main.code}</span>
          <Tween value={h.cash} format={wusd} />
        </div>
        <div class="hud-stat">
          <span class="label">{t("hud.followers")}</span>
          <Tween value={h.followers} format={compact} />
        </div>
        <div class="hud-stat">
          <span class="label">Day {h.day}</span>
          <span class="num">{displayClock(h.clock)}</span>
        </div>
      </div>
      <div class="hud-row hud-row-2">
        <button
          class={`gas-chip ${h.dgn < 2 ? "low" : ""} ${h.checkInReady ? "ready" : ""}`}
          onClick={() => openApp("wallet", { gas: "1" })}
          aria-label={`${CURRENCY.gas.name}: ${h.dgn.toFixed(1)} ${CURRENCY.gas.code}${h.checkInReady ? ", daily check-in ready" : ""}`}
        >
          <span class="label">{CURRENCY.gas.icon} {CURRENCY.gas.code}</span>
          <span class="num">{h.dgn < 100 ? h.dgn.toFixed(1) : Math.round(h.dgn)}</span>
          {h.checkInReady && <span class="gas-dot" aria-hidden="true" />}
        </button>
        <button class="help-btn" onClick={() => (helpOpen.value = "help")} aria-label="How to play" title="How to play">
          ?
        </button>
        {sharedMode.value ? <span class="world-badge" title="Shared world: the server sets the time">🌐 World</span> : (
        <div class="speed" role="group" aria-label="Game speed">
          {SPEEDS.map(({ s, label }) => (
            <button key={s} class={h.speed === s ? "on" : ""} onClick={() => setSpeed(s)} aria-pressed={h.speed === s}>
              {label}
            </button>
          ))}
        </div>
        )}
      </div>
    </header>
  );
}
